var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",attrs:{"id":"AddReports","data-app":""}},[_c('h1',[_vm._v(_vm._s(_vm.titulo))]),_c('reportForm',{attrs:{"rif_list":_vm.rif_list,"bancos_e":_vm.bancos_e,"bancos_r":_vm.bancos_r}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }